import type { Locale, Timezone } from '@/__generated__/graphql';
import { createContext, useContext } from 'react';

/**
 * Cómo se traducen los enums del backend a lo que entiende `Intl`. Las tablas son del código existente
 * (`utils/i18n`), que `fsd/` no puede importar: `FsdContext` las inyecta con `RegionMappingsProvider`
 * (el mismo patrón que el activador de idioma).
 */
export interface RegionMappings {
  /** El locale BCP 47 (`es-CL`, `en-US`…) del enum `Locale`; `undefined` si no lo conoce. */
  localeToBcp47: (locale: Locale) => string | undefined;
  /** La zona IANA (`America/Santiago`…) del enum `Timezone`; `undefined` si no la conoce. */
  timeZoneToIana: (timezone: Timezone) => string | undefined;
}

// Contexto y hook en un `.ts` aparte del provider por `react-refresh/only-export-components`.
export const RegionMappingsContext = createContext<RegionMappings | null>(null);

export function useRegionMappings(): RegionMappings {
  const mappings = useContext(RegionMappingsContext);
  if (!mappings) throw new Error('useRegionMappings necesita un RegionMappingsProvider');
  return mappings;
}
